import Menu from './Menu';

const Header = () => {
    return (
        <header className="header">
            <div className="title-wrapper">
                <div className="title">Nancy Du Lab</div>
                <div className="tagline">Understanding How Cancer Spreads - and How to Stop it</div>
            </div>
            <Menu />
        </header>
    );
}

export default Header;